export default __webpack_public_path__ + "static/media/TransformDutil02.f780f0c5.gif";